/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserProjectResponseV3LogoFromJSON, InternalUserProjectResponseV3LogoToJSON, } from './InternalUserProjectResponseV3Logo';
/**
 * @export
 */
export const InternalUserProjectResponseV3TypeEnum = {
    Project: 'project'
};
/**
 * Check if a given object implements the InternalUserProjectResponseV3 interface.
 */
export function instanceOfInternalUserProjectResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('companyName' in value) || value['companyName'] === undefined)
        return false;
    return true;
}
export function InternalUserProjectResponseV3FromJSON(json) {
    return InternalUserProjectResponseV3FromJSONTyped(json, false);
}
export function InternalUserProjectResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'companyName': json['company_name'],
        'highLevelPitch': json['high_level_pitch'] == null ? undefined : json['high_level_pitch'],
        'product': json['product'] == null ? undefined : json['product'],
        'tagline': json['tagline'] == null ? undefined : json['tagline'],
        'logo': json['logo'] == null ? undefined : InternalUserProjectResponseV3LogoFromJSON(json['logo']),
    };
}
export function InternalUserProjectResponseV3ToJSON(json) {
    return InternalUserProjectResponseV3ToJSONTyped(json, false);
}
export function InternalUserProjectResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'company_name': value['companyName'],
        'high_level_pitch': value['highLevelPitch'],
        'product': value['product'],
        'tagline': value['tagline'],
        'logo': InternalUserProjectResponseV3LogoToJSON(value['logo']),
    };
}
